import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import { connect } from "react-redux";
import { addToCart, updateContent } from "../actions/cartAction";
import {
  productsTable,
  newCategory,
  newProduct,
  newItem,
} from "../firebase/content";
import Editable from "./Editable";
import EditableImage from "./EditableImage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faMinusCircle } from "@fortawesome/free-solid-svg-icons";

class Products extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showToast: false,
    };
  }

  addNewCategory() {
    let newCat = newCategory();
    this.props.content[productsTable].push(newCat);
    this.props.updateContent({ ...this.props.content });
  }

  addNewProduct(category) {
    let newProd = newProduct();
    category.products.push(newProd);
    this.props.updateContent({ ...this.props.content });
  }

  addNewItem(product) {
    let newIt = newItem();
    product.items.push(newIt);
    this.props.updateContent({ ...this.props.content });
  }

  deleteItem(product, index) {
    product.items.splice(index, 1);
    this.props.updateContent({ ...this.props.content });
  }

  deleteProduct(category, index) {
    category.products.splice(index, 1);
    this.props.updateContent({ ...this.props.content });
  }

  deleteCategory(index) {
    this.props.content[productsTable].splice(index, 1);
    this.props.updateContent({ ...this.props.content });
  }

  handleAddToCart(productId, itemId) {
    this.props.addToCart(productId, itemId);

    if (this.state.showToast) {
      this.setState({ showToast: false }, () => {
        // next tick
        setTimeout(() => this.setState({ showToast: true }), 0);
      });
    } else {
      this.setState({ showToast: true });
    }
  }

  render() {
    let { editable } = this.props;
    const { [productsTable]: categories } = this.props.content;
    return (
      <div className="products-section" id="products">
        {/* TOAST */}
        <ToastContainer
          position="top-end"
          className="p-3"
          style={{
            position: "fixed",
            top: 56,
            right: 0,
            zIndex: 2000,
            color: "white",
          }}
        >
          <Toast
            show={this.state.showToast}
            onClose={() => this.setState({ showToast: false })}
            delay={2000}
            autohide
            bg="success"
          >
            <Toast.Body>Sản phẩm đã được thêm vào giỏ hàng </Toast.Body>
          </Toast>
        </ToastContainer>

        <Container className="mb-4">
          <Row className="prod_intro">
            <Col sm={12} md={4} className="heading">
              <h1>SẢN PHẨM</h1>
            </Col>
            <Col sm={12} md={4}>
              <p>
                Hạt macca được chia làm ba size dựa trên đường kính hạt.
                <br />
                Size nhỏ : đường kính hạt &#60; 2.2 cm
                <br />
                Size trung : 2.2 cm &ge; đường kính hạt &le; 2.5 cm.
                <br />
                Size đại : đường kính hạt &ge; 2.6 cm.
                <br />
                Quy cách đóng gói: 500 gram và 250gram / Sản phẩm. <br />
                Sản phầm được đóng gói trong bịch hút chân không hoặc trong hộp
                giấy. <br />
                Dầu macca được đóng trong chai 30 ml và 100ml.
              </p>
            </Col>
            <Col sm={12} md={4}>
              <p>
                {" "}
                Luôn bảo quản sản phẩm ở nhiệt độ phòng, để nơi khô ráo, thoáng
                mát, tránh ánh nắng mặt trời trực tiếp. Với macca sấy nứt, hạn
                sử dụng (HSD) 1 năm. Sau khi mở túi sử dụng tốt nhất trong 7
                ngày, nếu để ngăn mát tủ lạnh nên sử dụng trong vòng 3 tuần. Với
                nhân macca khô sữa, HSD 7 ngày nếu bảo quản ở nhiệt độ thường, 1
                tháng nếu để trong ngăn mát tủ lạnh và 6 tháng nếu giữ ở ngăn
                đông. Với nhân macca sấy sữa, HSD 3 tháng. Với dầu macca, HSD 6
                tháng. HSD được tính kể từ ngày sản xuất.
              </p>
            </Col>
          </Row>
        </Container>
        <Container>
          {(categories || []).map((category, i) => (
            <Row className="product" key={category.id}>
              <Col
                className="product-category"
                md={{ span: 6, order: i % 2 ? 3 : 1 }}
                sm={{ span: 12 }}
              >
                <EditableImage
                  editable={editable}
                  object={category}
                  field="background"
                >
                  {({ url, select }) => {
                    return (
                      <div
                        className="product-category-background"
                        style={{
                          backgroundImage: "url(" + url + ")",
                        }}
                        onClick={select}
                      ></div>
                    );
                  }}
                </EditableImage>
                <div className="product-category-content">
                  <Editable editable={editable} object={category} field="name">
                    <h1 className="category-name">{category.name}</h1>
                  </Editable>
                  <Editable
                    editable={editable}
                    object={category}
                    field="description"
                  >
                    <p>{category.description}</p>
                  </Editable>
                  {editable ? (
                    <FontAwesomeIcon
                      icon={faMinusCircle}
                      onClick={() => this.deleteCategory(i)}
                    ></FontAwesomeIcon>
                  ) : (
                    ""
                  )}
                </div>
              </Col>
              <Col
                md={{ span: 6, order: i % 2 ? 1 : 12 }}
                sm={{ span: 12, order: 12 }}
              >
                <Row
                  className="product-list"
                  style={{
                    justifyContent:
                      category.products.length == 1
                        ? "center"
                        : i % 2
                        ? "flex-end"
                        : "flex-start",
                  }}
                >
                  {category.products.map((product, index) => (
                    <Col key={product.id} sm={6}>
                      <Card>
                        <EditableImage
                          editable={editable}
                          object={product}
                          field="picture"
                        >
                          {({ url, select }) => {
                            return (
                              <Card.Img
                                variant="top"
                                src={url}
                                onClick={select}
                              />
                            );
                          }}
                        </EditableImage>
                        <Card.Body>
                          <Editable
                            editable={editable}
                            object={product}
                            field="name"
                          >
                            <Card.Title className="cart-title">
                              {product.name}
                            </Card.Title>
                          </Editable>
                          {product.items.map((item, index) => (
                            <div key={index}>
                              <Button
                                className="btn-size-price"
                                key={item.id}
                                variant="outline-dark"
                                onClick={() => {
                                  if (!editable)
                                    this.handleAddToCart(product.id, item.id);
                                }}
                              >
                                <Editable
                                  editable={editable}
                                  object={item}
                                  field="size"
                                >
                                  <span>{item.size}</span>
                                </Editable>
                                <br />
                                <Editable
                                  editable={editable}
                                  object={item}
                                  field="price"
                                >
                                  <span>{item.price}</span>
                                </Editable>
                                .000đ
                              </Button>
                              {editable ? (
                                <FontAwesomeIcon
                                  className="del-item-icon"
                                  icon={faMinusCircle}
                                  onClick={() =>
                                    this.deleteItem(product, index)
                                  }
                                ></FontAwesomeIcon>
                              ) : (
                                ""
                              )}
                            </div>
                          ))}
                          {editable ? (
                            <FontAwesomeIcon
                              icon={faPlusCircle}
                              onClick={() => this.addNewItem(product)}
                            ></FontAwesomeIcon>
                          ) : (
                            ""
                          )}
                        </Card.Body>
                      </Card>
                      {editable ? (
                        <Col sm={6}>
                          <FontAwesomeIcon
                            icon={faMinusCircle}
                            onClick={() => this.deleteProduct(category, index)}
                          ></FontAwesomeIcon>
                        </Col>
                      ) : (
                        ""
                      )}
                    </Col>
                  ))}

                  {editable ? (
                    <Col sm={6}>
                      <FontAwesomeIcon
                        className="add-prod-icon"
                        icon={faPlusCircle}
                        onClick={() => this.addNewProduct(category)}
                      ></FontAwesomeIcon>
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>
              </Col>
            </Row>
          ))}
          {editable ? (
            <Row className="product">
              <FontAwesomeIcon
                icon={faPlusCircle}
                onClick={this.addNewCategory.bind(this)}
              ></FontAwesomeIcon>
            </Row>
          ) : (
            ""
          )}
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    content: state.content,
    images: state.images,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart() {
      dispatch(addToCart(...arguments));
    },
    updateContent() {
      dispatch(updateContent(...arguments));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Products);
